import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { Subscription } from '../../../types/subscription';
import {  SubscriptionStatus, PaymentStatus } from '../../../types/enums';
//import sharedStyles from '../../SharedPageStyles.module.css';
import pageStyles from '../../Page.module.css';
import Icon from '../../../components/common/Icon';
type OpenDeleteDialogFn = (subscription: Subscription) => void;

// دوال مساعدة لعرض الحالات بألوان
const renderSubscriptionStatus = (status: SubscriptionStatus) => {
  const styles: { [key in SubscriptionStatus]: { color: string, text: string } } = {
    [SubscriptionStatus.ACTIVE]: { color: 'green', text: 'نشط' },
    [SubscriptionStatus.EXPIRED]: { color: 'red', text: 'منتهي' },
    [SubscriptionStatus.PENDING]: { color: 'orange', text: 'معلق' },
  };
  const style = styles[status] || { color: 'black', text: status };
  return <span style={{ color: style.color, fontWeight: 'bold' }}>{style.text}</span>;
};

const renderPaymentStatus = (status: PaymentStatus) => {
  const styles: { [key in PaymentStatus]: { color: string, text: string } } = {
    [PaymentStatus.PENDING]: { color: 'orange', text: 'بانتظار الدفع' },
    [PaymentStatus.PAID]: { color: 'green', text: 'مدفوع' },
    [PaymentStatus.FAILED]: { color: 'red', text: 'فشل الدفع' },
  };
  const style = styles[status] || { color: 'black', text: status };
  return <span style={{ color: style.color, fontWeight: 'bold' }}>{style.text}</span>;
};

export const getSubscriptionColumns = (openDeleteDialog: OpenDeleteDialogFn): ColumnDef<Subscription>[] => [
  {
    header: 'المحامي',
    accessorFn: (row) => row.lawyer?.name || 'غير محدد',
  },
  {
    header: 'حالة الاشتراك',
    accessorKey: 'status',
    cell: ({ row }) => renderSubscriptionStatus(row.original.status),
  },
  {
    header: 'حالة الدفع',
    accessorKey: 'payment_status',
    cell: ({ row }) => renderPaymentStatus(row.original.payment_status),
  },
  {
    header: 'تاريخ البدء',
    accessorFn: (row) => new Date(row.start_date).toLocaleDateString('ar-EG'),
  },
  {
    header: 'تاريخ الانتهاء',
    accessorFn: (row) => new Date(row.end_date).toLocaleDateString('ar-EG'),
  },
  {
    header: 'الرسوم',
    accessorKey: 'fee',
    cell: ({ row }) => `${row.original.fee} ر.س`,
  },
  {
    id: 'actions',
    header: 'إجراءات',
    cell: ({ row }) => {
      const subscription = row.original;
      return (
        <div className={pageStyles.actionButtons}>
          <Link to={`/admin/subscriptions/edit/${subscription.id}`} className={`${pageStyles.actionButton} ${pageStyles.edit}`} title="تعديل">
             <Icon as={FaEdit} style={pageStyles.icon } />
          </Link>
          <button onClick={() => openDeleteDialog(subscription)} className={`${pageStyles.actionButton} ${pageStyles.delete}`} title="حذف">
             <Icon as={FaTrashAlt} style={pageStyles.icon } />
          </button>
        </div>
      );
    },
  },
];
